<template>
	<div class="modal-wrapper">
		<div class="warning-container">
			<div class="warning-modal-title">
				{{ title }}
			</div>
			<div class="warning-modal-body">
				{{ text }}
			</div>
			<button class="warning-btn button-light-blue" @click="onConfirm" v-text="'OK'" />
		</div>
	</div>
</template>

<script>
import { ModalMixin } from '~/assets/vue/mixins'
import { capitalize } from '~/assets/util/helpers'

export default {
	name: 'ModalWizardRenew',
	mixins: [ModalMixin],
	props: {
		options: {
			type: Object,
			required: true
		}
	},
	computed: {
		cameraType () {
			return this.options.camera && this.options.camera.metadata && capitalize(this.options.camera.metadata.cameraType)
		},
		title () {
			return this.cameraType === 'Action' ? this.$tc('modals.wizardRenew.titleImportant') : this.$tc('modals.wizardRenew.title')
		},
		text () {
			const airOwnText = `${this.$tc('modals.wizardRenew.mainText[0]')} ${this.cameraType} ${this.$tc('modals.wizardRenew.mainText[1]')} ${this.cameraType} ${this.$tc('modals.wizardRenew.mainText[2]')}`
			return this.cameraType === 'Action' ? this.$tc('modals.wizardRenew.goProText') : airOwnText
		}
	}
}
</script>
